// Utility functions for dashboard

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "FRW",
  }).format(amount)
}

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat("en-US").format(num)
}

export const formatPercentage = (value: number, total: number): string => {
  if (total === 0) return "0%"
  return `${Math.round((value / total) * 100)}%`
}

export const getDateRange = (days: number): { startDate: string; endDate: string } => {
  const endDate = new Date()
  const startDate = new Date()
  startDate.setDate(startDate.getDate() - days)

  return {
    startDate: startDate.toISOString().split("T")[0],
    endDate: endDate.toISOString().split("T")[0],
  }
}

export const downloadFile = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    paid: "success",
    pending: "warning",
    free: "info",
    waived: "secondary",
    used: "success",
    unused: "danger",
    entered: "primary",
    exited: "warning",
  }
  return colors[status] || "secondary"
}

export const calculateTrend = (current: number, previous: number): { value: number; isPositive: boolean } => {
  if (previous === 0) return { value: 0, isPositive: true }
  const change = ((current - previous) / previous) * 100
  return {
    value: Math.round(change),
    isPositive: change >= 0,
  }
}
